import * as React from 'react';
import { useContext } from 'react';

import { type PROGRAM_JOIN_ERRORS } from 'bundles/enterprise-legacy-learner-home/constants/ProgramJoinModalErrors';

export type EnterpriseLearnerFlowOptimizationContextType = {
  error?: string;
  programJoinErrorCode?: keyof typeof PROGRAM_JOIN_ERRORS;
  isEnrolling?: boolean;
  showOptimizedLearnerFlow?: boolean;
  onJoiningSuccess?: () => void;
  enrollIntoCourse?: (options?: { isAutoEnrollment?: boolean }) => Promise<null>;
  navigationUrl?: string | null;
  setNavigationUrl?: (url: string | null) => void;
  isTrackingComplete?: boolean;
  setTrackingComplete?: (complete: boolean) => void;
  willAutoEnroll?: boolean;
  isLoadingLfo?: boolean;
};

const EnterpriseLearnerFlowOptimizationContext = React.createContext<EnterpriseLearnerFlowOptimizationContextType>({});

export const useEnterpriseLearnerFlowOptimization = () => {
  const learnerFlowOptimizationData = useContext(EnterpriseLearnerFlowOptimizationContext);
  return learnerFlowOptimizationData;
};

export default EnterpriseLearnerFlowOptimizationContext;
